import React from "react";
import { NavLink } from "react-router-dom";
import { Button } from "@flashtalking/rhombus-react";

import { HOME_ROUTE } from "utils/constants";

export default function HomeButton(){
	return (
		<NavLink
			to={HOME_ROUTE}
			title="Creative Manager Home">
			<Button>Creative Manager Home</Button>
		</NavLink>
	);
}
